// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3EfiX","head":"Card_head__AQHBX","title":"Card_title__2QNqY","errField":"Card_errField__2E5sY"};